var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.loading.length > 0)?_c('div',{staticClass:"common-loading"},[_c('div',{staticClass:"loading-spinner"},[_c('b-spinner',{attrs:{"label":"読み込み中"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }